import { useSettingsStore } from '@st/core/stores/useSettingsStore'

export function useEventStatsVisibility() {
  const { settings } = storeToRefs(useSettingsStore())

  const isEventStatsVisible = computed(
    () => settings.value?.frontSportEventsStatisticsEnabled,
  )

  return {
    isEventStatsVisible,
  }
}
